// Map dtype to human-readable name
function getChargeTypeName(dtype) {
  let names = {
    LateFeeCharge: 'Late Fee',
    MiscFeeCharge: 'Miscellaneous Fee',
    RetailFeeCharge: 'Retail Fee',
    TxFeeCharge: 'Transaction Fee',
    InstallmentCharge: 'Installment',
    TransferCharge: 'Transfer',
  }
  return names[dtype] || dtype
}

// Check if entry is aggregated
export function isAggregated(entry) {
  return Array.isArray(entry?.entries) && entry.entries.length > 0
}

// Check if entry has notes (single or aggregated)
export function hasNotes(entry) {
  if (isAggregated(entry)) {
    return entry.entries.some(e => e.notes)
  }
  return !!entry?.notes
}

// Get formatted notes text for display
export function getNotesText(entry) {
  if (isAggregated(entry)) {
    // Show each note with charge type label
    return entry.entries
      .filter(e => e.notes)
      .map(e => `${getChargeTypeName(e.dtype)}: ${e.notes}`)
      .join('\n')
  }
  return entry?.notes || ''
}
